
import API from '../config/api.js'

export const MemberService = {    
  
    getAllMembersBySearch(search) {
        return API.get(`api/member/list/se=${search}`);
    },
    
    getClubMembersBySearch(search) {
        return API.get(`api/club-member/list/se=${search}`);
    },   

    getMembersByOfficeRole(search, role) {
        return API.get(`api/office-member/${role}/list/se=${search}`);
    },  


    getClubMembersList(search, page) {
        return API.get(`api/member/club/list/se=${search}?page=${page}`);
    },

    getClubMemberInfo(id) {
        return API.get(`api/member/info/${id}`);
    },

    update(id,data) {
        return API.post(`api/member/update/${id}`,data);
    },

    create(data) {
        return API.post(`api/member/create`,data);
    },

    userUpdate(id,data) {
        return API.post(`api/user/member/update/${id}`,data);
    },

    dropMember(id) {
        return API.post(`api/member/drop/${id}`);
    },

    getServiceProjectMembers(id, search){
        return API.get(`api/service-project/${id}/committee-members/se=${search}`);
    },

    getRegionChairManList() {
        return API.get(`api/region-chairmen/list`);
    },

    getZoneChairManList() {
        return API.get(`api/zone-chairmen/list`);
    },

    


}



